export default "__VITE_ASSET__C3MAc2Zj__"